export default __webpack_public_path__ + "static/media/alert-octagon.9909d8b1.svg";